import React from 'react';
import type { TreeProps } from 'rc-tree';
import RcTree from 'rc-tree';

import { TreeWrapper } from './RcTree.styles';

function Tree(props: TreeProps) {
  return (
    <TreeWrapper>
      <RcTree {...props} />
    </TreeWrapper>
  );
}

Tree.defaultProps = {
  prefixCls: 'rc-tree',
};

export default Tree;
